import { writable, get } from 'svelte/store';
export default class DataProvider {
    constructor(options) {
        this._options = options;
        this._selectedCategoryId = writable(null);
        this._selectedSubCategoryId = writable(null);
    }
    set selectedCategoryId(status) {
        this._selectedCategoryId.set(status);
    }
    set selectedSubCategoryId(status) {
        this._selectedSubCategoryId.set(status);
    }
    get selectedCategoryId() {
        return get(this._selectedCategoryId);
    }
    get selectedSubCategoryId() {
        return get(this._selectedSubCategoryId);
    }
    get selectedCategoryIdSubs() {
        return this._selectedCategoryId;
    }
    get selectedSubCategoryIdSubs() {
        return this._selectedSubCategoryId;
    }
    get showSiteUrl() {
        return this._options.showSiteUrl;
    }
    get servicesGroupId() {
        return this._options.servicesGroupId;
    }
    get structureGroupId() {
        return this._options.structureGroupId;
    }
    get vocabularyGroupId() {
        return this._options.vocabularyGroupId;
    }
}
